export const demoComponent = {
  key: 'demoComponent',
  name: 'Demo Component',
  siteIdentifier: 'global',

  paramSays: 'The params prop says: {params}',
};
